import { useContext } from "react";
import UserContext from "../context/UserContext";
import { isFeatureAllowed } from "./FeatureAccess";
import Layout from "../Layout";
import { AiOutlineWarning } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const withFeatureRestriction = (Component, feature) => {
  return (props) => {
    const { packageType } = useContext(UserContext);
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!isFeatureAllowed(packageType, feature)) {
      return (
        <Layout>
          <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 bg-white border border-red-300 rounded-lg shadow-md">
            <AiOutlineWarning className="text-red-500 text-6xl mb-4" />
            <h2 className="text-xl font-semibold text-red-600 mb-2">
              {t("package.upgrade_required")}
            </h2>
            <p className="text-gray-600 text-center mb-4">
              {t("package.upgrade_message")}
            </p>
          </div>
        </Layout>
      );
    }

    return <Component {...props} />;
  };
};

export default withFeatureRestriction;
